import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { PaginationResponse } from "@/core/services/api/interfaces/PaginationResponse";
import ApiService from "@/core/services/ApiService";
import { AxiosRequestConfig } from "axios";
import Swal from "sweetalert2";
import { Notification } from "@/core/services/api/interfaces/manager/Notification";

@Module
export default class NotificationsModule extends VuexModule {
  pagination = new PaginationResponse<Notification>();

  get notifications(): Notification[] {
    return this.pagination.data;
  }

  get notificationsTopBar(): Notification[] {
    return this.pagination.data.slice(0, 5);
  }

  get notificationsTotal(): number {
    return this.pagination.total;
  }

  get notificationsCurrentPage(): number {
    return this.pagination.current_page;
  }

  get notificationsPerPage(): number {
    return this.pagination.per_page;
  }

  @Action({ rawError: true })
  [Actions.COMMON_NOTIFICATIONS_LOAD](page = 1, per_page = 100) {
    if (!this.context.getters.isIndividualOrHas2FA) {
      return;
    }
    return ApiService.manager.notification
      .list({
        params: { page, per_page },
      } as AxiosRequestConfig)
      .then(ApiService.unwrapPaginationResponse)
      .then((response) => {
        this.context.commit(Mutations.COMMON_NOTIFICATIONS_SET, response);

        this.context.commit(
          Mutations.COMMON_REQUEST_DONE,
          Actions.COMMON_NOTIFICATIONS_LOAD
        );
      });
  }

  @Action({ rawError: true })
  [Actions.COMMON_NOTIFICATIONS_REMOVE](notification) {
    return ApiService.manager.notification
      .remove(notification as Notification)
      .then(() => this.context.dispatch(Actions.COMMON_NOTIFICATIONS_LOAD))
      .catch(console.error);
  }

  @Action({ rawError: true })
  [Actions.COMMON_NOTIFICATIONS_PURGE]() {
    return Swal.fire({
      text: "You are about to purge all notifications. Are you sure?",
      icon: "question",
      buttonsStyling: false,
      confirmButtonText: "Yes, purge all!",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      customClass: {
        confirmButton: "btn fw-bold btn-light-danger",
        cancelButton: "btn fw-bold btn-light-white",
      },
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }
      // Go to page after successfully login
      return ApiService.manager.notification
        .purge()
        .then(() => this.context.dispatch(Actions.COMMON_NOTIFICATIONS_LOAD))
        .catch(console.error);
    });
  }

  @Mutation
  [Mutations.COMMON_NOTIFICATIONS_SET](pagination) {
    this.pagination = pagination;
  }

  @Mutation
  [Mutations.COMMON_NOTIFICATIONS_RESET]() {
    this.pagination = new PaginationResponse<Notification>();
  }
}
